<template>
    
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div class="d-flex flex-row mt-20 ms-20">

        <div class="card bg-primary text-white p-15  mb-25  col-md me-3">
          <div class="fw-bold">TOTAL DES DETTES</div>
          <div class="fw-bold fs-30">{{ formatMontant(totalDette) }}</div>
        </div>
        
        <div class="card bg-primary text-white p-15  mb-25 col-md">
          <div class="fw-bold">TOTAL DES DETTES DE CE MOIS</div>
          <div class="fw-bold fs-30">{{ formatMontant(totalDetteDuMois) }}</div>
        </div>

        <div class="card bg-primary text-white p-15  mb-25 col-md mx-3">
          <div class="fw-bold">TOTAL DES DETTES DE CE JOUR</div>
          <div class="fw-bold fs-30">{{ formatMontant(totalDetteDuJour) }}</div>
        </div>
      </div>


      <div
        class="card-head box-shadow bg-white d-md-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
      >
        <form class="search-box position-relative" @submit.prevent="rechercher">
          <input
            type="text"
            v-model="searchTerm"
            @keyup="rechercher"
            class="form-control shadow-none text-black rounded-0 border-0"
            placeholder="Rechercher un encaissement"
          />
          <button
            type="submit"
            class="bg-transparent text-primary transition p-0 border-0"
          >
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
        <div class="d-sm-flex align-items-center">
        <a
            class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
            href="#"
            data-bs-toggle="modal"
            data-bs-target="#AddElementModal"
          >
            <i class="flaticon-plus position-relative ms-5 fs-12"></i>
            Ajouter un reglement
        </a>
          
          <button
            class="default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mt-10 mt-md-0"
            type="button"
          >
            Export
            <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
          </button>
        </div>
      </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="table-responsive">
          <table class="table text-nowrap align-middle mb-0">
            <thead>
              <tr>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                >
                  #
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                >
                  Date
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                >
                  Client
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  Montant regler
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  Reste à payer
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  Vente
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(reg, index) in elements" :key="index">
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ (reg) ? reg.id : "" }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                 {{ (reg) ? format_Date(reg.dateReglement) : "" }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                 {{ (reg.vente) ?
                  " [ "+reg.vente.client.code+" ] "+reg.vente.client.nom+" "+reg.vente.client.prenoms
                   : "" }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                 {{ (reg.montant) ? reg.montant : "" }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                 {{ (reg.restAPayer) ? reg.restAPayer : "" }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                 {{ (reg.vente.id) ? reg.vente.id : "" }}
                </td>
                <td
                class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0"
                >
                    <div class="dropdown">
                        <span class="badge text-white bg-primary fs-15 dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                            Actions
                            <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                        </span>
                        <ul class="dropdown-menu">
                            <!-- <li>
                            <a
                                class="dropdown-item d-flex align-items-center"
                                href="javascript:void(0);"
                                data-bs-toggle="modal"
                                data-bs-target="#AddElementModal"
                                @click="modification(reg)"
                            >
                                <i
                                class="flaticon-pen lh-1 me-8 position-relative top-1"
                                ></i>
                                Modifier
                            </a>
                            </li> -->
                            <li>
                            <a
                                class="dropdown-item d-flex align-items-center"
                                href="javascript:void(0);" @click="suppression(reg.id,elements,'reglement','ce reglement')"
                            >
                                <i
                                class="flaticon-delete lh-1 me-8 position-relative top-1" 
                                ></i>
                                Annuler
                            </a>
                            </li>
                        </ul>
                    </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
          <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
        </div>
      </div>
    </div>

    <AddReglementModal :item="selectedItem"   @close="recharger"/>

  </template>
  
  <script lang="ts">
  import { defineComponent, ref, onMounted } from 'vue';
  import { paginationFields } from '../Utilities/paginationFields';
  import { error, suppression, format_Date, formatMontant } from '../../utils/utils';
  import ApiService from "../../services/ApiService";
  import  { Reglement }  from '../../models/Reglement';
  import AddReglementModal from './AddReglementModal.vue';
  import PaginationComponent from '@/components/Utilities/Pagination.vue';

  export default defineComponent({
    name: "ListeReglement",
    components: {
      AddReglementModal,
      PaginationComponent
    },
    setup: () => {

      const elements = ref<Array<Reglement>>([])
      const selectedItem = ref(0);
      const element = ref<Reglement>();
      const totalDette = ref(0);
      const totalDetteDuMois = ref(0);
      const totalDetteDuJour = ref(0);

     
      function modification(item) {
        element.value = item;
        selectedItem.value = item.id;
      }

      // BEGIN PAGINATE
        const searchTerm = ref('');
        const page = ref(1);
        const totalPages = ref(0);
        const limit = ref(10);
        const totalElements = ref(0);

        const handlePaginate = ({ page_, limit_ }) => {
          try {
            page.value = page_;
            getAll(page_, limit_, searchTerm.value);
          } catch (error) {
            //
            
          }
        };
        function rechercher(){
          getAll(page.value, limit.value, searchTerm.value );
        }
      // END PAGINATE

      const recharger = () => {
        getAll();
      };
     

      onMounted( async () => {
        console.log("mounted called 1");
        await getAll();
        console.log("mounted called 2");
        await getTotalDettes();
        console.log("mounted called 3");
        await getTotalDettesDuMois();
        console.log("mounted called 4");
        await getTotalDettesDuJour();
      })

      function formatDateTimeLocal(date: Date): string {
        return date.getFullYear() + '-' + 
          String(date.getMonth() + 1).padStart(2, '0') + '-' + 
          String(date.getDate()).padStart(2, '0') + ' ' +
          String(date.getHours()).padStart(2, '0') + ':' +
          String(date.getMinutes()).padStart(2, '0') + ':' +
          String(date.getSeconds()).padStart(2, '0');
      }

      function getAll(page = 1, limi = 10, searchTerm = '') {
        return ApiService.get(`reglements?page=${page}&limit=${limi}&mot=${searchTerm}&`)
        .then(({ data }) => {
          // console.log('result', data.data.data);
          elements.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          // console.log("yes",data.data.data);
        })
        .catch(({ response }) => {
          error(response.data)
        });
      } 

      function getTotalDettes() {
        return ApiService.get(`totaldettes`)
        .then(({ data }) => {
          totalDette.value = data.data.totalDettes;
          console.log('result', data.data.totalDettes);
        })
        .catch(({ response }) => {
          error(response.data)
        });
      }

      function getTotalDettesDuMois() {

        const dateDebut = new Date();
        dateDebut.setDate(1);
        dateDebut.setHours(0, 0, 0, 0);

        const dateFin = new Date();
        dateFin.setMonth(dateFin.getMonth() + 1);
        dateFin.setDate(0);
        dateFin.setHours(23, 59, 59, 999);

        const debutFormatted = formatDateTimeLocal(dateDebut);
        const finFormatted = formatDateTimeLocal(dateFin);

        //console.log('testets', debutFormatted, "irirririri", finFormatted);
        return ApiService.get(`totaldettes?dateDebut=${debutFormatted}&dateFin=${finFormatted}&`)
        .then(({ data }) => {
          totalDetteDuMois.value = data.data.totalDettes;
          console.log('result mois', data.data.totalDettes);
        })
        .catch(({ response }) => {
          console.log("erreur du mois", response);
          error(response.data)
        });

      }

      function getTotalDettesDuJour() {

        const dateDebut = new Date();
        dateDebut.setHours(0, 0, 0, 0);
        
        const dateFin = new Date();
        dateFin.setHours(23, 59, 59, 999);

        const debutFormatted = formatDateTimeLocal(dateDebut);
        const finFormatted = formatDateTimeLocal(dateFin);
        console.log('testets jour', debutFormatted, "irirririri", finFormatted);
        return ApiService.get(`totaldettes?dateDebut=${debutFormatted}&dateFin=${finFormatted}&`)
        .then(({ data }) => {
          totalDetteDuJour.value = data.data.totalDettes;
          console.log('result jour', data.data.totalDettes);
        })
        .catch(({ response }) => {
          console.log("erreur du jour", response);
          error(response.data)
        });
      }
      

      return { 
        getAll,
        suppression,
        modification,
        elements,
        recharger,
        selectedItem,

        page,
        totalPages,
        totalElements,
        limit,
        searchTerm,
        handlePaginate,
        rechercher,
        format_Date,
        formatMontant,
        totalDette,
        totalDetteDuMois,
        totalDetteDuJour
      };
    }

  });
  </script>